import types from '../actions/types';
import { quoters } from '../ecosystem.config';
import { compareValues } from '../helpers';

const initialState = { };

const cleanableState = {
  quoteId: 0,
  rateCode: 0,
  
  fees: [],
  deductibleQuantity: 1,
  cashAmount: '0',
  maxFeeCount: '0',
  maxFeeAmount: '0',
  insuredAmount: 0,
  productCode: 0,

  feesOptional: [],
  deductibleQuantityOpt: 1,
  cashAmountOptional: '0',
  maxFeeCountOptional: '0',
  maxFeeAmountOptional: '0',
  optionalSelected: false,
  insuredAmountOptional: 0,
  productCodeOptional: 0,

  validFrom: "",
  validTo: "",

  hasStandardQuotation: false,
  errorMessage: ''
};

const rateCodeSOA = 8;
const rateCodeStandard = 16;
const rateCodeEconomic = 19; 

let fees, feesOptional = [], quoteId, type, quote, rateCode, options = {};
let deductibleQuantity = 1, deductibleQuantityOpt = 1, hasStandardQuotation = false;
let insuredAmount, insuredAmountOptional;
let maxFeeAmount, maxFeeAmountOptional;
let productCode, productCodeOptional;

const setLabel = (value, label) => {
  return value === 1 ? 'CONTADO' : label;
}

const setFees = (type, rates, paymentsPlan = null, inDues = false) => {
  let fees = [], feesAux = [];

  //FeeAmount: 12, Price: 369, FirstFee: 39, OtherFees: 30

  if(paymentsPlan) {
    paymentsPlan.map(plan => {
      if (rates[`cuota${plan.clave}`] && rates[`cuota${plan.clave}`] != 0) 
        fees.push({ value: plan.clave, label: setLabel(plan.clave,plan.valor), amount: rates[`cuota${plan.clave}`] })
    });
  } else {
    switch (type) {
      case 'monto':
        fees.push({ value:  1, label:   'CONTADO', amount: Math.round(rates['monto']) });
        fees.push({ value: 12, label: '12 CUOTAS', amount: Math.round(rates['montoMensual'] * 12) });
        break;

      case 'amount':
        rates.map(rate => {
          feesAux.push({ value: rate.FeeAmount, label: setLabel(rate.FeeAmount, rate.FeeAmount + ' CUOTAS'), amount: rate.Price});
        });
        feesAux.sort(compareValues('value'));
        fees.push(feesAux.shift());
        fees.push(feesAux.pop());
        break;

      case 'quotation':
        for (let i = 1; i <= 12; i++) {
          if (rates[`cuota${i}`] && rates[`cuota${i}`] != 0) 
            fees.push({ value: i, label: setLabel(i, i + ' CUOTAS'), amount: rates[`cuota${i}`] })
        }
        break;

      case 'payment':
        for (let i = 1; i <= 12; i++) {
          if (rates[`Payment${i}`] && rates[`Payment${i}`] != 0) 
            fees.push({ value: i, label: setLabel(i, i + ' CUOTAS'), amount: rates[`Payment${i}`] * (inDues ? i : 1) })
        }
        break;
    }
  }
  return fees;
}

const quotation = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};

    case types.CLEAN_QUOTATION:
      return { ...state, ...cleanableState};

    case types.CLEAN_QUOTATION_ERROR:
      return { ...state, errorMessage: ''};

    case types.SET_OPTIONAL_QUOTATION_VALUE:
      return { ...state, optionalSelected: action.payload.value};

    case types.SET_QUOTATION:
      
      type = action.payload.type;
      quote = action.payload.quote;
      options = action.payload.options;

      switch (type) {

        case quoters.YATES.key:
          fees = setFees(null, quote.quotation, quote.paymentsPlan);
          quote = quote.quotation;
          quoteId = quote.idCotizacion;
          break;

        case quoters.PYME.key:
        case quoters.PYMEFARMACIA.key: {
          const montos = quote.montos.find(monto => monto.codigoModulo === options.coverageModule);
          fees = setFees('monto', montos, quote.paymentsPlan);
          quoteId = quote.idCotizacion;
          break;
        }

        case quoters.AUTOSSOA.key:
        case quoters.AUTOSSTANDARD.key:
        case quoters.AUTOSECONOMICO.key:
          if(quote) {
            hasStandardQuotation = quote.hasStandardQuotation;
            rateCode = options.economic ? rateCodeEconomic : (options.withOptional ? rateCodeStandard : rateCodeSOA );
            
            quoteId = quote.quotationNumber;
            quote = quote.quotation;
            let rate = null, rateOptional = null;

            if (hasStandardQuotation && options.withOptional && !options.economic)
                 quote.Rates.filter(item => { if (item.Code == rateCode) { if (item.MechanicalAssistance) rate = item; else rateOptional = item; } });
            else quote.Rates.filter(item => { if (item.Code == rateCode) rate = item; });

            if (hasStandardQuotation && options.withOptional && !options.economic) {
              feesOptional = setFees('payment', rateOptional);
              deductibleQuantityOpt = rateOptional.DeductibleQuantity;
            }
            fees = setFees('payment', rate);
            deductibleQuantity = rate.DeductibleQuantity;

            //Only SOA isFinal = true
            if(options.isFinal && state.cashAmount !== fees[0].amount) {
              return { ...state, 
              errorMessage: 'Los datos ingresados no coinciden con el tipo de vehículo seleccionado.'};
            }
          } else {
           return { ...state, ...cleanableState, 
            errorMessage: 'Hubo un error al obtener la cotización'};
          }
          break;

        case quoters.HOGAR.key:
          quoteId = quote.Id ? parseInt(quote.Id, 0) : 0;
          fees = quote.Fees ? setFees('amount', quote.Fees) : [];
          break;

        case quoters.APERSONALES.key:
          quoteId = quote.Id ? parseInt(quote.Id, 0) : 0;
          fees = quote.GoldRate ? setFees('payment', quote.GoldRate, null, true) : [];
          feesOptional = quote.SilverRate ? setFees('payment', quote.SilverRate, null, true) : [];
          insuredAmount = quote.GoldRate ? quote.GoldRate.InsuredAmount : 0;
          insuredAmountOptional = quote.SilverRate? quote.SilverRate.InsuredAmount : 0;
          productCode = quote.GoldRate ? quote.GoldRate.ProductCode : 0;
          productCodeOptional = quote.SilverRate ? quote.SilverRate.ProductCode : 0;
          break;
      }

      return {
        
        ...state, quoteId, fees, feesOptional, rateCode, deductibleQuantity, hasStandardQuotation,
        cashAmount:   fees.length > 0 ? fees[0].amount: '0',
        maxFeeCount:  fees.length > 0 ? fees[fees.length - 1].value: '0',
        maxFeeAmount: fees.length > 0 ? Math.round((fees[fees.length - 1].amount / fees[fees.length - 1].value) * 100) / 100 : '0',
        insuredAmount, productCode,

        
        deductibleQuantityOpt: feesOptional.length > 0 ? deductibleQuantityOpt : 1,
        cashAmountOptional:    feesOptional.length > 0 ? feesOptional[0].amount: '0',
        maxFeeCountOptional:   feesOptional.length > 0 ? feesOptional[feesOptional.length - 1].value: '0',
        maxFeeAmountOptional:  feesOptional.length > 0 ? Math.round((feesOptional[feesOptional.length - 1].amount / feesOptional[feesOptional.length - 1].value) * 100) / 100 : '0',
        insuredAmountOptional, productCodeOptional,

        validFrom: quote.ValidFrom ? quote.ValidFrom : "",
        validTo: quote.ValidTo ? quote.ValidTo : "",

        errorMessage: quote.respuesta ? quote.respuesta.mensaje : '',
      };

    default:
      return state;
  }
};

export default quotation;
